const HOURS = 60 * 60 * 1000; // milliseconds in an hour

interface ISymmetricSplitConfig {
    readonly type: "symmetric";
    readonly splitMinimum: number;
    readonly splitTotal: number;
}

interface IAsymmetricSplitConfig {
    readonly type: "asymmetric";
    readonly smallSplitMin: number;
    readonly bigSplitMin: number;
    readonly bigSplitMax?: number;
    readonly onlyFreezeBigPeriods?: boolean;
    readonly splitTotal: number;
}

export type TSplitConfig = ISymmetricSplitConfig | IAsymmetricSplitConfig;

interface ISplitConfigCollection {
    readonly [key: string]: TSplitConfig;
}

export const SPLIT_CONFIGS = {
    SYMMETRIC_2_10: {
        type: "symmetric",
        splitMinimum: 2 * HOURS,
        splitTotal: 10 * HOURS
    },
    SYMMETRIC_4_8: {
        type: "symmetric",
        splitMinimum: 4 * HOURS,
        splitTotal: 8 * HOURS
    },
    SYMMETRIC_2_8: {
        type: "symmetric",
        splitMinimum: 2 * HOURS,
        splitTotal: 8 * HOURS
    },
    ASYMMETRIC_7_2: {
        type: "asymmetric",
        smallSplitMin: 2 * HOURS,
        bigSplitMin: 7 * HOURS,
        splitTotal: 10 * HOURS
    },
    ASYMMETRIC_CALIFORNIA: {
        type: "asymmetric",
        smallSplitMin: 2 * HOURS,
        bigSplitMin: 8 * HOURS,
        bigSplitMax: 10 * HOURS,
        splitTotal: 10 * HOURS,
        onlyFreezeBigPeriods: true
    }
} as const satisfies ISplitConfigCollection;
